import React from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"

export default class IndexPage extends React.Component {
  state = {
    name: null,
    email: null,
  }

  _handleChange = (e) => {
    console.log({
      [`${e.target.name}`]: e.target.value,
    })
    this.setState({
      [`${e.target.name}`]: e.target.value,
    })
  }

  _handleSubmit = (e) => {
    e.preventDefault()

    console.log("submit", this.state)

    addToMailchimp(this.state.email, this.state)
      .then(({ msg, result }) => {
        console.log("msg", `${result}: ${msg}`)
        window.location = "https://www.nextandco.com.au/mailchimp-thankyou"

        if (result !== "success") {
          // throw msg
          // window.location = 'https://www.nextandco.com.au/mailchimp-thankyou'
        }
        // alert(msg)
      })
      .catch((err) => {
        console.log("err", err)
        // alert(err)
      })
  }

  render() {
    return (
      <div className="mailchimp-form">
        <div className="form-content">
          <h4 className="mailchimp-form-heading">TheNext</h4>
          <p>By Next&Co</p>
          <p>
            Stay up to date and find the latest insights about digital media,
            SEO, technology and design.
          </p>
        </div>
        <div className="form-container">
          <h5 className="form-title">Subscribe to our newsletter</h5>
          <form onSubmit={this._handleSubmit}>
            <input
              className="input"
              required
              type="text"
              onChange={this._handleChange}
              placeholder="Name:"
              name="fname"
            />
            <input
              className="input"
              required
              type="email"
              onChange={this._handleChange}
              placeholder="Email:"
              name="email"
            />

            <input className="btn btn-invert" type="submit" value="Subscribe" />
          </form>
        </div>
      </div>
    )
  }
}
